export const getAllCategories = (state) => {
  if (state.categories.response) {
    return state.categories.response.data;
  } else {
    return null;
  }
};
